/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import React, { useEffect, useCallback, useState } from 'react';
import { shallowEqual } from 'react-redux';

import { useAppDispatch, useAppSelector } from '../../../../store';
import { setShowInstancePicker } from '../../store/header/actions';
import { isShowInstancePicker } from '../../store/header/selectors';
import { loadInstances } from '../../store/instances/actions';
import {
  areInstancesUpdating,
  areInstancesLoading,
  selectAllInstances,
  selectCachedInstances
} from '../../store/instances/selectors';
import Panel from '../panel/Panel';
import Instances from './Instances';

const InstancesPanel = () => {
  const [actualInstances, setActualInstances] = useState(
    selectCachedInstances() || []
  );
  const dispatch = useAppDispatch();

  const showInstancePicker = useAppSelector(isShowInstancePicker);

  const closePanel = useCallback(() => {
    dispatch(setShowInstancePicker(false));
  }, [dispatch]);

  const loading = useAppSelector(areInstancesLoading);
  const updating = useAppSelector(areInstancesUpdating);
  const instances = useAppSelector(selectAllInstances, shallowEqual);

  useEffect(() => {
    if (showInstancePicker) {
      dispatch(loadInstances());
    }
  }, [dispatch, showInstancePicker]);

  useEffect(() => {
    if (instances?.length) {
      setActualInstances(instances);
    }
  }, [instances]);

  if (!showInstancePicker) {
    return null;
  }

  return (
    <Panel
      panelRoot="full-screen-panel-root"
      className="InstancePanel"
      onClose={closePanel}
      title="Instances">
      <Instances
        instances={actualInstances}
        loading={loading}
        updating={updating}
      />
    </Panel>
  );
};

export default InstancesPanel;
